// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string; // optional: "Admin" | "User"
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, token, loading } = useAuth();

  // Prevent flashing while loading token/user from localStorage
  if (loading) return null;

  // No token or no user = force logout to login page
  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  // Role check (if required)
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
